// The site's name and address in one place. Free address now; set VITE_SITE_URL when the domain is bought.
export const SITE_NAME = 'nostalgia.';
export const SITE_URL: string = import.meta.env.VITE_SITE_URL ?? 'https://nostalgia-page.pages.dev';
export const PLANNED_DOMAIN = 'nostalgia.page';
